module.exports = __webpack_public_path__ + "static/media/img2.714bc78b.jpg";